import React, { useRef } from 'react';

import PropTypes from 'prop-types';
import { Notification, Icon, IconButton, Typography } from '@telus-uds/components-web';
import Upload from '@telus-uds/palette-allium/build/web/icons/Upload';
import Check from '@telus-uds/palette-allium/build/web/icons/Check';

import Label from './label';
import { UploadButton } from './css';
import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json'; 

const DefectAttachment = ({ fieldData, setFieldData }) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: { labelAttachements, attachementsNote }
    }
  } = locale === 'en-US' ? EN : FR;
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = event => {
    const file = event.target.files[0];
    setFieldData(previousValue => ({ ...previousValue, attachment: file }));
  };

  return (
    <div>
      <Label labelName={`${labelAttachements}`} />
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
      <Notification copy="en">{attachementsNote}</Notification>
      <UploadButton type="button" onClick={handleButtonClick}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem'
          }}
        >
          <Icon icon={Upload} variant={{ size: 'small' }} />
          <Typography block>Upload</Typography>
        </div>
      </UploadButton>
      {fieldData.attachment && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            marginTop: '1rem'
          }}
        >
          <Icon icon={Check} variant={{ color: 'success' }} />
          <Typography block>{fieldData.attachment.name}</Typography>
          <IconButton
            action="close"
            onPress={() =>
              setFieldData(previousValue => ({
                ...previousValue,
                attachment: ''
              }))
            }
            accessibilityLabel="Reduce"
          />
        </div>
      )}
    </div>
  );
};

DefectAttachment.propTypes = {
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.shape({
      name: PropTypes.string
    })
  }).isRequired
};

export default DefectAttachment;
